/**
 * Check if user can delete a POI
 * @param {number} createdBy - UserID of the POI creator
 * @param {Object} authData - Auth data from UserContext
 * @param {Object} authData.userPermissions - User's permissions object
 * @param {Array} authData.userGroups - User's groups
 * @param {Object} authData.user - Current user object with UserID
 * @returns {boolean}
 */
export const canUserDeletePOI = (createdBy, { userPermissions, userGroups, user }) => {
    if(userGroups && userGroups.length && userGroups.includes("Admin")){
      return true
    }

    if((createdBy && user && createdBy === user.UserID) &&
      (userPermissions && userPermissions.pois?.delete)
    ){
      return true
    }

    return false
  }
